import React, { useEffect, useState } from "react";
import axios from "axios";
import { CircularProgress, Typography, Container } from "@material-ui/core";
import DriverMedicalCertificateRequestForm from "./DriverMedicalCertificateRequestForm";

export default function DriverMedicalCertificatePublicPage() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    async function fetchConfig() {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL_BASE}/public/driver-medical-certificate/config`
        );
        setConfig(response.data);
      } catch (error) {
        setConfig({ enabled: false, price: 0 });
      } finally {
        setLoading(false);
      }
    }
    fetchConfig();
  }, []);

  return (
    <Container maxWidth="md" style={{ paddingTop: 48, paddingBottom: 48 }}>
      {loading && <CircularProgress />}

      {!loading && !config?.enabled && (
        <Typography variant="h6">
          Esta función no está disponible por el momento.
        </Typography>
      )}

      {!loading && config?.enabled && !completed && (
        <DriverMedicalCertificateRequestForm
          mode="public"
          price={config.price}
          onCompleted={() => setCompleted(true)}
        />
      )}

      {completed && (
        <Typography variant="h6">
          ¡Gracias! Hemos recibido tu solicitud, revisa tu correo para más
          detalles.
        </Typography>
      )}
    </Container>
  );
}
